export enum DynamicPropertyDataTypes {
  STRING = 'STRING',
  INTEGER = 'INTEGER',
  DATE_TIME = 'DATE_TIME',
}
